<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 16 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" :fill="fill" r="8"/>
    <path d="M6 12.9149C6 12.9618 6.03444 13 6.07671 13C6.0955 13 6.11272 12.9931 6.12525 12.9809L9.42231 10.6772C9.77456 10.3749 10 9.90238 10 9.37076V3.08513C10 3.03822 9.96556 3 9.92329 3C9.9045 3 9.88728 3.00695 9.87476 3.01911L6.57769 5.3228C6.22544 5.62509 6 6.09764 6 6.62926V12.9149Z" :fill="iconFill" />
  </svg>
</template>

<script>
export default {
  name: 'Premier',
  props: {
    width: {
      type: String,
      required: false,
      default: '16px'
    },
    height: {
      type: String,
      required: false,
      default: '16px'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#282828'
    },
    iconFill: {
      type: String,
      required: false,
      default: '#F9F9F9'
    },
  },
};
</script>
